import React from "react";
import { IconWithBackground } from "../../../../ui/components/IconWithBackground";
import { Button } from "../../../../ui/components/Button";
import { Loader } from "../../../../ui/components/Loader";
import { FeatherCreditCard } from "@subframe/core";

interface PaymentCardProps {
  title: string;
  count?: number;
  amount?: number;
  currencySymbol?: string;
  loading?: boolean;
  onViewDetails: () => void;
  variant?: "success" | "error";
}

export const PaymentCard: React.FC<PaymentCardProps> = ({
  title,
  count = 0,
  amount = 0,
  currencySymbol = "₹",
  loading = false,
  onViewDetails,
  variant = "success",
}) => {
  return (
    <div className="flex grow shrink-0 basis-0 flex-col items-start gap-4 rounded-md border border-solid border-neutral-border bg-default-background px-6 py-6">
      <div className="flex items-center gap-2">
        <IconWithBackground variant={variant} icon={<FeatherCreditCard />} />
        <span className="text-body-bold font-body-bold text-subtext-color">
          {title}
        </span>
      </div>

      <div className="flex w-full items-end justify-between">
        <div className="flex flex-col items-start gap-1">
          <span className="text-body font-body text-subtext-color">Count</span>
          <span className="text-heading-2 font-heading-2 text-default-font">
            {count}
          </span>
        </div>
        <div className="flex flex-col items-start gap-1">
          <span className="text-body font-body text-subtext-color">Amount</span>
          <span
            className={`text-heading-2 font-heading-2 ${
              variant === "success" ? "text-success-600" : "text-error-600"
            }`}
          >
            {`${
              variant === "error" ? "-" : ""
            }${currencySymbol}${amount.toLocaleString("en-IN")}`}
          </span>
        </div>
      </div>

      <Button size="small" onClick={onViewDetails}>
        View Details
      </Button>
    </div>
  );
};
